import styled from "styled-components";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";

const Container = styled.div``;

const Carrier = () => {
  return (
    <Container>
      <PageHeader title="Karrier" />
      <Footer />
    </Container>
  );
};

export default Carrier;
